<template>
  <draggable
    :list="items"
    :sort="true"
    ghost-class="ghost"
    @start="startDrag($event)"
    @end="endDrag($event)"
    ref="iso"
    :id="`iso-${stage}`"
    class="signage"
  >
    <div
      v-for="sign in items"
      :key="sign.id"
      class="iso-item sign"
      :class="sign.physical"
    >
      <pictos-card :sign="sign" />
    </div>
  </draggable>
</template>

<script>
// @ is an alias to /src
import { PictosCard } from "./index";
import { Isotope } from "@/vendor";
import draggable from "vuedraggable";

export default {
  name: "PictosTray",
  data() {
    return {
      dragging: false,
      intervalId: null,
    };
  },
  components: {
    PictosCard,
    draggable,
  },
  props: {
    items: Array,
    stage: String,
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      let vm = this;
      clearInterval(this.intervalId);
      this.intervalId = null;
      this.intervalId = setInterval(function() {
        vm.checkStatus();
      }, 300);
    },
    checkStatus() {
      if (this.items && this.$refs) {
        clearInterval(this.intervalId);
        this.initIso();
      }
    },
    initIso() {
      this.iso = null;
      let isoEl = document.getElementById(`iso-${this.stage}`);
      console.log("init iso");
      this.iso = new Isotope(isoEl, {
        itemSelector: ".iso-item",
        layoutMode: "packery",
        transitionDuration: 0,
        hiddenStyle: {
          opacity: 0,
        },
        visibleStyle: {
          opacity: 1,
        },
      });
    },
    layout() {
      if (this.iso) {
        this.iso.layout();
      }
    },
    startDrag() {
      this.dragging = true;
    },
    endDrag(el) {
      console.log(el.srcElement.id);
      this.dragging = false;
    },
  },
};
</script>
